import { apiClient } from "../../base_url/config"
import type { LoginResponse } from "./types"

export const loginWithPhone = async (phoneNumber: string): Promise<LoginResponse> => {
  try {
    // Normalize phone number - ensure it starts with 
    let normalizedPhone = phoneNumber.trim()
    if (normalizedPhone.startsWith('0')) {
      normalizedPhone = '' + normalizedPhone.substring(1)
    } else if (!normalizedPhone.startsWith('')) {
      normalizedPhone = '' + normalizedPhone
    }
    

    // Create FormData for the request
    const formData = new FormData()
    formData.append('phone', normalizedPhone)

    const response = await apiClient.post('/qr/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        'platform': 'qr',
        // lang will be added automatically by interceptor
      },
      timeout: 10000, // 10 seconds timeout
    })


    // Extract token from response
    const token = response.data.token || response.data.access_token || response.data.data?.token

    return response.data
  } catch (error: any) {

    if (error.response) {
      // Server responded with error status
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`)
    } else if (error.request) {
      // Request was made but no response received
      throw new Error('Network error: No response from server')
    } else {
      // Something else happened
      throw new Error(error.message || 'Unknown error occurred')
    }
  }
}

// Function to add token to API requests
export const setAuthToken = (token: string | null) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete apiClient.defaults.headers.common['Authorization']
  }
}

// Function to check if token is valid (you can customize this based on your API)
export const validateToken = async (token: string): Promise<boolean> => {
  try {
    const response = await apiClient.get('/user/profile', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      timeout: 5000,
    })

    return response.status === 200
  } catch (error) {
    return false
  }
}